import Vue from 'vue';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import axios from 'axios';

Vue.use(VueI18Next);

const language = localStorage.getItem('lang') || 'en';

i18next.init({
  lng: language,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
    defaultVariables: {
      brand: process.env.BRAND_CONFIG.name,
    },
  },
  resources: {},
});

function loadLanguage(lang) {
  if (i18next.hasResourceBundle(lang, 'translation')) {
    return;
  }

  axios(`/locales/${lang}.json?v${process.env.PACKAGE_VERSION}`).then((response) => {
    i18next.addResourceBundle(lang, 'translation', response.data);
  });
}

if (language !== 'en') {
  loadLanguage('en');
}

loadLanguage(language);

i18next.on('languageChanged', loadLanguage);

export const vuei18n = new VueI18Next(i18next);
export const i18n = i18next;
